<template>
  <div :class="$style.container">
    <div
      v-for="(transactions, date) in transactionsGroups"
      :key="date"
    >
      <div
        v-m-t="10"
        :class="$style.date"
        v-text="date"
      ></div>
      <crypto-payment-success
        v-if="isShownSuccessBanner"
        v-m-t="10"
        :transaction="transaction"
        :loading="loading"
      />
      <crypto-transaction
        v-for="(item, idx) in transactions.reverse()"
        :key="`${idx}_${item.status}`"
        v-m-t="10"
        v-opacity="loading ? .5 : 1"
        v-pointer-events="loading ? 'none' : 'all'"
        :transaction="item"
        :currency="transaction.currency"
      />
    </div>
  </div>
</template>

<script>
import CryptoTransaction from 'molecules/crypto/CryptoTransaction';
import CryptoPaymentSuccess from 'molecules/crypto/CryptoPaymentSuccess';

export default {
  name: 'CryptoPaymentList',
  components: {
    CryptoTransaction,
    CryptoPaymentSuccess,
  },
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    transactionsGroups: {
      type: Object,
      default: () => ({}),
    },
    loading: Boolean,
  },
  computed: {
    isShownSuccessBanner() {
      return this.transaction.status === 'SUCCESS';
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative

  .date
    +font-type('regular', 12, 34)
    color: var(--color-blue-black)
    text-align: center
    opacity: .5
</style>
